import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterSectionProps {
  selectedType: string;
  selectedRegion: string;
  searchQuery: string;
  onTypeChange: (type: string) => void;
  onRegionChange: (region: string) => void;
  onSearchChange: (query: string) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  selectedType,
  selectedRegion,
  searchQuery,
  onTypeChange,
  onRegionChange,
  onSearchChange,
}) => {
  const partnerTypes = [
    'All Types',
    'Government',
    'NGO',
    'Faith-Based',
    'University',
    'UN Agency',
    'Corporate',
  ];

  const regions = [
    'All Regions',
    'Africa',
    'Asia',
    'Europe',
    'North America',
    'South America',
    'Oceania',
  ];

  return (
    <div className="bg-card rounded-lg shadow-md p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-semibold text-foreground mb-2">
            Search Partners
          </label>
          <div className="relative">
            <Icon
              name="MagnifyingGlassIcon"
              size={20}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by name or description..."
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-foreground bg-background"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-foreground mb-2">
            Partner Type
          </label>
          <div className="relative">
            <Icon
              name="BuildingOfficeIcon"
              size={20}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
            <select
              value={selectedType}
              onChange={(e) => onTypeChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-foreground bg-background appearance-none"
            >
              {partnerTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={20}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-foreground mb-2">
            Region
          </label>
          <div className="relative">
            <Icon
              name="GlobeAltIcon"
              size={20}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
            <select
              value={selectedRegion}
              onChange={(e) => onRegionChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-foreground bg-background appearance-none"
            >
              {regions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={20}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;